import React from "react";
import { Alert } from "@mui/material";

import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import WarningIcon from "@icons/myicons/warning-circle-filled.svg?react";

const Status = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

interface AddManuallyMessageProps {
  type?: "success" | "error";
  message?: string;
}

export const CreateAndUpdateResultMessage = ({
  message,
  type,
}: AddManuallyMessageProps) => {
  const { t } = useTranslation();

  if (type === "error") {
    return (
      <Status
        data-testid="result-alert-error"
        color="error"
        icon={<WarningIcon width="30px" height="30px" />}
      >
        {message}
      </Status>
    );
  }

  if (type === "success") {
    return (
      <Status data-testid="result-alert-success" color="success">
        {t("addManuallyPage.form.messages.success")}
      </Status>
    );
  }

  return null;
};
